import MarketplaceCollections from './MarketplaceCollections';

export default MarketplaceCollections;
